import { Button } from '@recipes/ui';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/**
 * Feature-local page header (the core web agent ships src/components/PageHeader; this
 * copy exists so the planning/admin areas do not block on it – dedupe later).
 */
export function FeaturePageHeader({
  title,
  description,
  backTo,
  actions,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  backTo?: string;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <header className="mb-4 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        {backTo && (
          <Button asChild variant="ghost" size="sm" className="-ml-2 mb-1">
            <Link to={backTo}>
              <ArrowLeft aria-hidden />
              {t('common.back')}
            </Link>
          </Button>
        )}
        <h1 className="text-2xl font-semibold leading-tight break-words">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
        {children}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

export function PageContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full max-w-6xl p-4 md:p-6 ${className ?? ''}`}>{children}</div>;
}
